import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';


const CommentsSection: FC = () => {
	const { width } = useResizeObserver()
	const { transData, list } = useTranslation('happyKids.comments');
	const itemList = list.map((item, index) => {
		return (
			<div className={classnames(styles['ac-comment-item'], styles[`ac-comment-item-${item.id}`], `ac-comment-item-${item.id}`)} key={index}>
				<div className={styles['ac-comment-avatar']}>
					<img loading='lazy' src={item.img} alt="" />
					<span className={styles['ac-comment-name']}>{item.name}</span>
					<div className={styles['cube']}></div>
				</div>
				<div className={styles['ac-comment-icon']}>
					{Array.from({ length: 5 }).map((_, i) => {
						return (
							<img loading='lazy' src={item.icon} alt="" key={i} />
						)
					})}
				</div>
				<div className={styles['ac-comment-item-context']}>
					<p>{item.content}</p>
				</div>
			</div>)
	})
	const phoneBetween = width < 768 ? 16 : 0
	const spaceBetween = width >= 1192 ? 24 : phoneBetween
	return (
		<section className={styles['ac-comment']}>
			<div className={styles['ac-comment-container']}>
				{width >= 1192 ?
					<img className={styles['ac-comment-img-1']} loading='lazy' src="https://web-data.zmlearn.com/image/mzVNR3XZQhAa1xnyb9racq/%E5%AE%B6%E9%95%BF-left-bg%402x.png" alt="" />
					: <img className={styles['ac-comment-img-1']} loading='lazy' src='https://web-data.zmlearn.com/image/iCx52ErbmwT2K57UuJGC75/%E5%AE%B6%E9%95%BF-left-bg%402x%20(1).png' alt="" />}
				{width >= 1192 ?
					<img className={styles['ac-comment-img-2']} loading='lazy' src="https://web-data.zmlearn.com/image/cVGmb6Au1fTRqKQYxP3s5s/%E5%AE%B6%E9%95%BF-right-bg%402x.png" alt="" />
					:
					<img className={styles['ac-comment-img-2']} loading='lazy' src="https://web-data.zmlearn.com/image/iVUrJk12bzaT88BYGYbv8M/%E5%AE%B6%E9%95%BF-right-bg%402x%20(2).png" alt="" />
				}
				<h1><span>{transData.title}</span></h1>
				<AcSwipe className={classnames(styles['ac-comment-banner'], 'ac-comment-banner')}
					loop={true}
					spaceBetween={spaceBetween}
					pagination={{ clickable: true, }}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					centeredSlides={true}
					slidesPerView={width >= 1192 ? 3 : 'auto'}
				>{itemList}</AcSwipe>

			</div>
		</section>
	);
}

export default CommentsSection
